import React from 'react';
import { observer } from 'mobx-react';
import MarkdownContent from './MarkdownContent';
import { Card, CardTitle, EmptyState } from './CompanyPage.styles';

const ProblemsView = observer(({ problems }) => {
  if (!problems || problems.length === 0) {
    return <EmptyState>No addressable problems have been added yet.</EmptyState>;
  }

  return (
    <>
      {problems.map((problem, i) => (
        <Card key={i}>
          <CardTitle style={{ marginBottom: 16 }}>Problem #{i + 1}</CardTitle>
          <MarkdownContent markdown={problem} />
        </Card>
      ))}
    </>
  );
});

export default ProblemsView;
